var setTitle = function setTitle(state, valor) {
  state.title = valor;
};
var setLogo = function setLogo(state, valor) {
  state.title = valor;
};
var setNamePainelDelete = function setNamePainelDelete(state, valor) {
  state.namePainelDelete = valor;
};
export { setTitle, setLogo, setNamePainelDelete };